import React from 'react';
import './FilterBar.css';
import ViewDetailsBtn from './Button';

const FilterBar = () => {
  return (
    <div className="filter-wrapper">
      <div className="filter-item">Type <span className="arrow">∨</span></div>
      <div className="divider"></div>
      <div className="filter-item">Price <span className="arrow">∨</span></div>
      <div className="divider"></div>
      <div className="filter-item">Area <span className="arrow">∨</span></div>
      <div className="divider"></div>
      <ViewDetailsBtn />
    </div>
  );
};

export default FilterBar;